import React from 'react'
import { ServiceSectionContainer } from './styles'
import ServiceCard from './service-card'
import { Text } from '../../styles/Components'
import { kebabCase } from 'lodash'

const ServiceSection = ({
  services,
  market,
  serviceType,
  showServiceInfo = true,
  showOnlyBookButton = false,
}) => {
  const serviceInfoBody = services[0]?.service?.serviceType?.serviceInfoBody
  const serviceInfoTitle = services[0]?.service?.serviceType?.serviceInfoTitle

  return (
    <ServiceSectionContainer id={kebabCase(serviceType.toLowerCase())}>
      <div className="service-card-list">
        {services.map((service) => (
          <ServiceCard
            key={service.id}
            service={service}
            market={market}
            showOnlyBookButton={showOnlyBookButton}
          />
        ))}
      </div>

      {((showServiceInfo && serviceInfoTitle && serviceInfoTitle.length) ||
        (showServiceInfo && serviceInfoBody && serviceInfoBody.length)) && (
        <>
          <div className="service-section-footer">
            <div className="content">
              {serviceInfoTitle && (
                <Text variant="medium" weight={600}>
                  {serviceInfoTitle}
                </Text>
              )}
              {serviceInfoBody && (
                <Text variant="large">{serviceInfoBody}</Text>
              )}
            </div>
          </div>
        </>
      )}
    </ServiceSectionContainer>
  )
}

export default ServiceSection
